import { createFileRoute } from '@tanstack/react-router'
import EditUserPopup from '../../../../../../containers/ManageUsers/components/EditUserPopup'


export const Route = createFileRoute(
  '/_authenticated/userManagement/user/$userId/edit/'
)({
  component: EditUserPopup
})
